export default __webpack_public_path__ + "static/media/S (22).ad28fcb6.png";